import MyMaor from "./MyMaor";

export default MyMaor;
